import { render, staticRenderFns } from "./SearchArticles.vue?vue&type=template&id=467a012a&scoped=true"
import script from "./SearchArticles.vue?vue&type=script&lang=js"
export * from "./SearchArticles.vue?vue&type=script&lang=js"
import style0 from "./SearchArticles.vue?vue&type=style&index=0&id=467a012a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467a012a",
  null
  
)

export default component.exports